export default __webpack_public_path__ + "static/media/metamask.09e5f554.svg";